import { IMedicalRecordAllele } from '@nkr/models/hla/hla-medical-record-allele';

export interface IRecipientHlaReviewHistory {
    id: number,
    recipientId: number,
    reviewedDateTime: string,
    reviewedByUserId: number,
    reviewedByName: string,
    reviewType: string,
    logDateTime: string,
    reviewedByInitials: string,
}

export interface IRecipientProfileHlaInfoPost {
    hlaA1: number,
    hlaA2: number,
    hlaB1: number,
    hlaB2: number,
    hlaBw1: number,
    hlaBw2: number,
    hlaC1: number,
    hlaC2: number,

    hlaDrb1: number,
    hlaDrb2: number,
    hlaHasDr51: boolean,
    hlaHasDr52: boolean,
    hlaHasDr53: boolean,

    hlaDqb1: number,
    hlaDqb2: number,
    hlaDqa1: number,
    hlaDqa2: number,

    hlaDpb1: number,
    hlaDpb2: number,

    labReviewDate: string,
    labReviewComplete: boolean,
    labReviewInitials: string,
}

export interface IRecipientProfileHlaInfo extends IRecipientProfileHlaInfoPost {

    alleles: IMedicalRecordAllele[] | null,

    hasAlleleData: boolean,
    hasHlaDiscrepancy: boolean,
    hasHlaMissingErrors: boolean,
    hlaDiscrepancyIsEquivalent: boolean,
    reviewHistoryList: IRecipientHlaReviewHistory[],
}

export interface IRecipientProfileHlaValues {
    hla: string,
    antigens: number[]
}

